// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".action-status-select[data-v-7d514223]{font-size:1.1em;background:#44a7dc;color:#fff;text-align:center;border-radius:10px}.action-status-select option[data-v-7d514223]{font-size:1.1em;padding:5px 0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
